var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23135 9.03533C1.44133 7.65775 1.05987 6.5329 0.829866 5.39268C0.489683 3.70632 1.26817 2.05901 2.55782 1.00789C3.10287 0.563651 3.72769 0.715435 4.05 1.29367L4.77765 2.59909C5.35441 3.63381 5.64278 4.15116 5.58558 4.69966C5.52839 5.24816 5.13947 5.69488 4.36164 6.58834L2.23135 9.03533ZM2.23135 9.03533C3.83042 11.8236 6.33986 14.3344 9.13133 15.9353M9.13133 15.9353C10.5089 16.7253 11.6337 17.1068 12.774 17.3368C14.4603 17.677 16.1077 16.8985 17.1587 15.6088C17.603 15.0638 17.4512 14.439 16.873 14.1167L15.5676 13.389C14.5328 12.8123 14.0155 12.5239 13.467 12.5811C12.9185 12.6383 12.4717 13.0272 11.5783 13.805L9.13133 15.9353Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDark);
export default __webpack_public_path__ + "static/media/mobile-dark.67de9f6c87edd87107f3d9470e8f1f52.svg";
export { ForwardRef as ReactComponent };